module.exports = __webpack_public_path__ + "static/media/gto.366c43e9.svg";